import { speedbumpText } from '@consumer/constants/disclaimers'

export const createSpeedBump = (uniqueContainerSelector: string) => {
  function handleLinkClick (event: Event) {
    // eslint-disable-next-line no-alert
    if (confirm(speedbumpText))
      window.open((event.target as HTMLAnchorElement).href, '_blank')
    event.preventDefault()
  }

  document.querySelectorAll(`${uniqueContainerSelector} a`).forEach((el: Element) => {
    el.addEventListener('click', handleLinkClick)
  })
}
